import React from 'react';

import * as styles from './SoapSticker.styles';

export interface SoapStickerProps {
  content: string;
}

export const SoapSticker = ({ content }: SoapStickerProps) => {
  return (
    <div css={styles.container}>
      <img
        src="https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltcbdf40410f2f3f96/purple_soap.png"
        alt={content}
      />
    </div>
  );
};
